import { api } from '@xtnd/web/shared/api';

interface QboConfigResponse {
  appId?: string;
  clientId?: string;
  clientSecret?: string;
  realmId?: string;
  accessToken?: string;
  refreshToken?: string;
  baseUrl?: string;
  redirectUri?: string;
  webhooksConfigured?: boolean;
  configured?: boolean;
  hasAccessToken?: boolean;
  hasRefreshToken?: boolean;
  tokenExpiresAt?: string;
}

interface QboOAuthUrlResponse {
  authUrl: string;
  state: string;
}

interface QboOAuthCallbackRequest {
  code: string;
  state: string;
  clientId: string;
  clientSecret: string;
  realmId: string;
}

interface QboTestConnectionResponse {
  success: boolean;
  companyInfo?: any;
  message: string;
}

class QboIntegrationApi {
  private readonly baseSource = '/tenants/current/qbo';

  /**
   * Get QBO configuration
   */
  async getConfig(): Promise<QboConfigResponse> {
    return api.get<QboConfigResponse>(`${this.baseSource}/config`);
  }

  /**
   * Generate OAuth authorization URL
   */
  async generateOAuthUrl(data: {
    clientId: string;
    clientSecret: string;
    redirectUri: string;
  }): Promise<QboOAuthUrlResponse> {
    return api.post<QboOAuthUrlResponse>(`${this.baseSource}/oauth/url`, data);
  }

  /**
   * Exchange OAuth code for tokens
   */
  async exchangeOAuthCode(data: QboOAuthCallbackRequest): Promise<void> {
    return api.post<void>(`${this.baseSource}/oauth/callback`, data);
  }

  /**
   * Test QBO API connection
   */
  async testConnection(): Promise<QboTestConnectionResponse> {
    return api.get<QboTestConnectionResponse>(`${this.baseSource}/test-connection`);
  }
}

export const qboIntegrationApi = new QboIntegrationApi();

export type { QboConfigResponse, QboOAuthUrlResponse, QboOAuthCallbackRequest, QboTestConnectionResponse };

